import { useState } from 'react';
import { ModelsTabName } from '../Types/Enums';
import useGlobals from './useGlobals';

const useModels = () => {
    const { userSettings, i18n } = useGlobals();
    const [currentTab, setCurrentTab] = useState<ModelsTabName>(ModelsTabName.chatModels);

    return {
        userSettings,
        i18n,
        currentTab,
        setCurrentTab,
    };
};

export default useModels;
